import { render } from "./FeaturedOnNews.vue?vue&type=template&id=0449c7de&scoped=true"
import script from "./FeaturedOnNews.vue?vue&type=script&lang=js"
export * from "./FeaturedOnNews.vue?vue&type=script&lang=js"

import "./FeaturedOnNews.vue?vue&type=style&index=0&id=0449c7de&scoped=true&lang=css"
import "./FeaturedOnNews.vue?vue&type=style&index=1&id=0449c7de&scoped=true&lang=css"
import "./FeaturedOnNews.vue?vue&type=style&index=2&id=0449c7de&scoped=true&lang=css"
import "./FeaturedOnNews.vue?vue&type=style&index=3&id=0449c7de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0449c7de"]])

export default __exports__